import { LOADING } from '../actions.type';

export function loading(loading) {
  return {
    type: LOADING,
    loading: loading
  };
}



// WEBPACK FOOTER //
// ./src/redux/loading/loading.actions.js